import React, { useState } from 'react';
import dompurify from 'dompurify';
import { VoteGroup } from './VoteGroup';
import { LoadingButton } from '../common/LoadingButton';

export const SingleGroupVote = ({ ballot, getGroup, currentGroup, currentGroupVote, handleSubmit, isPreview, handleOptionsUpdate, isJustSubmitted }) => {
    const [isSubmitting, setSubmitting] = useState(false)

    const sanitizer = dompurify.sanitize;

    const handleSingleGroupSubmit = (e) => {
        setSubmitting(true)
        handleSubmit(true, () => setSubmitting(false), () => setSubmitting(false))
    }

    return (
        <React.Fragment>
            {currentGroup && currentGroupVote && ballot &&
                <React.Fragment>
                    {ballot.ballotStatement &&
                        <div className="mb-4">
                            <span dangerouslySetInnerHTML={{ __html: sanitizer(ballot.ballotStatement) }} />
                        </div>
                    }
                    <form className="mb-4">
                        <VoteGroup currentGroup={currentGroup}
                            currentGroupVote={currentGroupVote}
                            handleOptionsUpdate={handleOptionsUpdate}
                            ballot={ballot}
                            isJustSubmitted={isJustSubmitted} />
                        {(!currentGroupVote.hasVoted || ballot.isVoteChange) &&
                            <LoadingButton className="btn"
                                onBtnClick={handleSingleGroupSubmit}
                                btnText="Submit"
                                isLoading={isSubmitting}
                                isSubmit="true"
                                isDisabled={isPreview}
                                confirmText="Are you sure you want to submit your vote preferences?" />}
                    </form>
                </React.Fragment>
            }
        </React.Fragment>
    );
}